import getPathFromId from '../util/getPathFromId';
import { ResolveDataConflictsResult } from '../api/OcifXlsxApi';

/**
 * The setFormDataValues batch that brings the open form in line with a resolution the server has
 * already persisted. A schedule's data sits in the form at its SubformField's path (getPathFromId of
 * the SubformField $id, which is the schedule prefix), in the stored `{ data: { ... } }` shape —
 * so tabs never opened are covered without their fields being mounted.
 */
export function buildConflictResolutionPatch(result: ResolveDataConflictsResult): Record<string, unknown> {
  const patch: Record<string, unknown> = {};

  result.resolved.forEach(item => {
    patch[`conflicts.${item.key}`] = item.cleared ? false : { reported: item.reported, calculated: item.calculated, resolved: item.resolved };
    const value = item.value ?? item.textValue;
    if (value != null) patch[`${getPathFromId(item.schedulePrefix)}.data.${item.fieldCode}`] = value;
  });

  result.scheduleStatuses.forEach(status => {
    patch[`${getPathFromId(status.schedulePrefix)}.data.uploadStatus`] = status.uploadStatus;
  });

  return patch;
}
